import React from 'react';

import { useQuery } from 'react-query';
import { DotBricksLoading, ListPagination, Search } from 'src/common/components';

import { fetchCallRescueMonitor } from './api';
import { List, Filter } from './components';
import { Action } from './constants';
import { CallRescueMonitorContext } from './context';
import { useCallRescueMonitorReducer } from './reducer';

const CallRescueMonitor: React.FC = () => {
  const [state, dispatch] = useCallRescueMonitorReducer();
  const { currentPage, search, totalCount, callRescueStatusFilter } = state;
  const { isLoading, isError } = useQuery(
    ['fetchCallRescueMonitor', { currentPage, search, callRescueStatusFilter }],
    fetchCallRescueMonitor,
    {
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        const { data } = response;
        dispatch({
          type: Action.SET_CALL_RESCUE_MONITOR,
          callRescueTests: data.results,
          totalCount: data.count,
        });
      },
    }
  );

  const handleSetPage = (newPage: number): void => {
    dispatch({
      type: Action.SET_PAGE,
      page: newPage,
    });
  };

  const handleSetSearch = (searchValue: string): void => {
    // only set new page when search has changed
    const hasSearchChanged = searchValue.length !== search.length;
    const newPage = hasSearchChanged ? 1 : undefined;
    dispatch({
      type: Action.SET_SEARCH,
      search: searchValue,
      currentPage: newPage,
    });
  };

  if (isError)
    return (
      <div className="sm:px-6 lg:px-8 sm:pb-2 flex flex-col h-full pt-8 overflow-x-auto overflow-y-hidden">
        <h2>We encounter an error in the call rescue monitor... </h2>
        <div className="flex mt-4">
          <p>Please report to engineering team</p>
        </div>
      </div>
    );

  if (isLoading) return <DotBricksLoading />;

  return (
    <CallRescueMonitorContext.Provider value={{ state, dispatch }}>
      <div className="sm:px-6 lg:px-8 sm:pb-2 flex flex-col h-full pt-8 overflow-x-auto overflow-y-hidden">
        <h2 className="sm:px-0 px-4">Call rescue monitor</h2>
        <div className="sm:px-0 flex flex-shrink-0 px-4 mt-4">
          <Search setSearch={handleSetSearch} placeholder="Search by name or phone" />
        </div>
        <Filter />
        <List />
        <ListPagination
          currentPage={currentPage}
          totalCount={totalCount}
          setCurrentPage={handleSetPage}
        />
      </div>
    </CallRescueMonitorContext.Provider>
  );
};

export default CallRescueMonitor;
